import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";

import Form from "./Form";

import { usePolicyPlanCustomRecordTemplateContext } from "../../../../contexts/PolicyPlanCustomRecordTemplateContext";

export default function ModalForm() {
  const { dispatch, actions, state } =
    usePolicyPlanCustomRecordTemplateContext();

  return (
    <>
      <Modal
        className="student inmodal auto without-overflow"
        show={state.showModal}
        onHide={() => actions.hideModal(dispatch)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {state.currentTemplate == null
              ? "Create a Custom Service"
              : "Edit a Custom Service"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form />
        </Modal.Body>
      </Modal>
    </>
  );
}
